import { useMutation } from "@tanstack/react-query";
import { BAJAR_PDF, DESLINDE_PDF } from "./endpoints";
import { downloadFileRequest } from "./axiosClient";

export const useDescargarConstancia = () => {
	return useMutation({
		mutationFn: ({ idInscripcion, tokenSeguridad, isDeslinde }) => {
			return downloadFileRequest(
				`${
					isDeslinde ? DESLINDE_PDF : BAJAR_PDF
				}?idi=${idInscripcion}&pdf=I&tks=${tokenSeguridad}`
			);
		},
	});
};
